var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.162.532c-.18.002-.363.01-.548.033-.368.048-.771.173-1.08.482L.448 13.132a1.549 1.549 0 000 2.177l9.242 9.242a1.549 1.549 0 002.177 0l12.085-12.084c.307-.308.434-.715.482-1.08.048-.366.033-.728.033-1.081V2.394A1.87 1.87 0 0022.606.532h-7.912c-.172 0-.351-.002-.532 0zm.017 1.064c.156-.004.334 0 .515 0h7.912a.79.79 0 01.798.798v7.912c0 .37-.002.704-.033.947s-.081.364-.166.45l-12.085 12.1a.48.48 0 01-.681 0l-.067-.083-9.175-9.159a.48.48 0 010-.681l12.1-12.085c.084-.083.221-.135.466-.166.123-.017.26-.03.416-.033zM19.68 3.19c-1.17 0-2.128.958-2.128 2.128 0 1.17.958 2.128 2.128 2.128 1.17 0 2.128-.958 2.128-2.128 0-1.17-.958-2.128-2.128-2.128zm0 1.064c.594 0 1.064.47 1.064 1.064 0 .594-.47 1.064-1.064 1.064-.594 0-1.064-.47-1.064-1.064 0-.594.47-1.064 1.064-1.064z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0.25
  })));
}

export default SvgCommonIconCoupon;